// Utils
import { isCurrentBrowserLogoutAction } from '../../auth/authUtils';

// Types
import { Action } from 'redux';
import { SOCKET_CONNECT, SOCKET_FORCE_DISCONNECT } from '../../utils/socket/socketConstants';
import { BaseTimerVisibilityState } from './baseTimerVisibilityState';
import { VisibleConnectionStatus } from './visibleConnectionStatusTypes';
import { LOGIN_SUCCESS, REGISTER_SUCCESS } from '../../auth/authConstants';
import { ELECTRON_APP_SLEEP } from '../../../common/electron/electronConstants';

/**
 * The socket isn't connected - a "Trying to reconnect" status message will be shown.
 *
 * NOTE: This state uses a timeout to transition to the disconnected state.
 */
export class InterruptedState extends BaseTimerVisibilityState {
    static stateKey = VisibleConnectionStatus.interrupted;

    nextState(action: Action) {
        if (isCurrentBrowserLogoutAction(action)) return VisibleConnectionStatus.idle;

        switch (action.type) {
            case SOCKET_CONNECT:
                return VisibleConnectionStatus.connected;
            case ELECTRON_APP_SLEEP:
            case SOCKET_FORCE_DISCONNECT:
            case this.timeoutActionName:
                return VisibleConnectionStatus.disconnected;
            case LOGIN_SUCCESS:
            case REGISTER_SUCCESS:
                return VisibleConnectionStatus.connecting;
            default:
                return undefined;
        }
    }
}
